<div class="card bg-white dark:bg-gray-800 shadow rounded-lg flex items-start">
  <!-- <div class="p-2">
    <div class="flex-none">
      <div class="flex flex-col text-center shadow rounded-md overflow-hidden">
        <span class="text-xs font-bold text-white bg-red-600 dark:bg-red-700 px-3 py-1">
          {{ newsItem.date | date: 'MMM' | uppercase }}
        </span>
        <span class="text-lg font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 px-3">
          {{ newsItem.date | date: 'dd' }}
        </span>
      </div>
    </div>
  </div> -->

  <div class="p-2 pb-3 flex-grow flex flex-col justify-between">
    <div class="flex justify-between items-center w-full">
      <span
        class="text-xs font-semibold inline-block py-1 px-2 uppercase rounded text-blue-600 bg-blue-200 dark:text-blue-200 dark:bg-blue-600"
      >
        {{ item.doc_type }}
      </span>
      <span>
        {{ item.date | date: "MMM" | uppercase }}
      </span>
    </div>

    <div>
      <h2 class="font-bold text-xl text-gray-900 dark:text-white line-clamp-2">
        {{ item.title }}
      </h2>
      <p class="text-gray-700 dark:text-gray-300 mt-2 text-sm line-clamp-3">
        {{ item.abstract }}
      </p>
      <div class="text-xs font-semibold dark:text-white text-gray-900">
        <span>published</span>: {{ item.date | date }}
      </div>
    </div>

    <div class="mt-3">
      <span
        *ngFor="let keyword of item.foundKeywords"
        class="text-xs font-semibold inline-block py-1 px-2 bg-green-200 dark:bg-green-700 text-green-600 dark:text-green-300 rounded-full mr-1 mb-1"
      >
        {{ keyword }}
      </span>
    </div>
  </div>
</div>
